module.exports = __webpack_public_path__ + "static/territorio6-499e6744540b13f96e723e7d2c6940b8.png";